import src from "IMAGE";
export default { src, width: 1360, height: 171, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mOIY2CILmJgKADi/HwGhpwUBobEYAaGQKB4TDIDQwIAac0GPgiZQWYAAAAASUVORK5CYII="};
